module.exports = __webpack_public_path__ + "static/media/video_consent_audio_bengali.4f9ef6eb.mp3";